import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi everyone, I'm <span className="yellow">Hamza Shaikh </span>
            from <span className="yellow"> Karachi, Pakistan.</span>
            <br />
            I’m a MERN stack developer with over a year of experience working
            with modern web technologies
            <br />
            I recently graduated with a degree in Software Engineering (BSSE)
            from UBIT Karachi.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Exploring new tech trends and tools
            </li>
            <li className="about-activity">
              <ImPointRight /> Listening to podcasts
            </li>
          </ul>

          <p style={{ color: "yellow" }}>
            Always curious, always learning—excited to build cool stuff! 🚀{" "}
          </p>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
